import axios, { AxiosError } from 'axios';
import {envF} from '../../../env';

export interface ILotInventoryCheckResponse {
  lotFreeForInventory: boolean;
  errMessage: string;
}

const checkLotInventoryAvailability = async (idLotGlobal: string): Promise<ILotInventoryCheckResponse> => {
  try {
    const jwtToken = localStorage.getItem('TokenData') as string;
    const token = `Bearer ${JSON.parse(jwtToken).accessToken}`;
    const header = {
      headers: {
        Authorization: token,
      },
    };

    const response = await axios.get<ILotInventoryCheckResponse>(`${envF.REACT_APP_API_GATEWAY_PATH}/Lots/${idLotGlobal}/Inventory/CheckAvailability`, header);

    return {
      lotFreeForInventory: response.data.lotFreeForInventory,
      errMessage: response.data.errMessage || '',
    };
  } catch (error) {
    // Обработка ошибок axios
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError;
      return {
        lotFreeForInventory: false,
        errMessage: `Ошибка запроса: ${axiosError.response?.status} - ${axiosError.message}`,
      };
    } else {
      // Обработка других ошибок
      return {
        lotFreeForInventory: false,
        errMessage: `Ошибка: ${error instanceof Error ? error.message : 'Неизвестная ошибка'}`,
      };
    }
  }
};

export default checkLotInventoryAvailability;